import React from 'react';

// Feather has no shield-check and the heroicons one looked stretched next to the Feather set,
// so this is Feather's shield outline plus a check, drawn at the same 24-grid / 2px stroke as react-icons/fi.
const ShieldCheckIcon: React.FC<{ className?: string }> = ({ className }) =>
    <svg className={className} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        <path d="M9 12l2 2 4-4" />
    </svg>;

export default ShieldCheckIcon;
